import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import { Box, Button, Icon } from '@node-space/ui-components'

interface DashboardCardProps {
  title: string
  onClick: (step: string) => void
  step?: string
  queue: string
  type: 'neutral' | 'success'
  isActive: boolean
  testId?: string
}

export const DashboardCard = ({
  title,
  step,
  onClick,
  queue,
  type = 'neutral',
  isActive = false,
  testId = 'dashboard-card',
}: DashboardCardProps) => {
  const { t } = useTranslation()

  return (
    <Box
      className={clsx(
        'flex min-h-[220px] min-w-[198px] max-w-[198px] flex-col gap-y-4 gap-x-6 justify-between items-start self-stretch select-none rounded-xl border py-4 px-6 hover:shadow-lg cursor-pointer',
        type === 'success' ? 'bg-surface-status-success' : 'bg-surface-interactive',
        isActive ? 'border-stroke-interactive-active shadow-toast' : 'border-stroke-interactive'
      )}
      onClick={() => step && onClick(step)}
      data-testid={testId}
    >
      <Box
        className={clsx(
          'w-full',
          type === 'success' ? 'text-foreground-status-success' : 'text-foreground-prominent'
        )}
      >
        {step && (
          <p className={clsx('text-body-regular-small')}>
            {t('embeddedCustomers.dashboard.step')} {step}
          </p>
        )}
        <Box className="flex items-center">
          <p className={clsx('text-label')}>{title}</p>
          <Button variant="ghost" iconElement={<Icon name="Info" size="medium" />} />
        </Box>
        <div
          className={clsx(
            'h-px w-full',
            type === 'success' ? 'bg-accent-status-success' : 'bg-stroke-static'
          )}
        />
      </Box>
      <Box
        className={clsx(
          type === 'success' ? 'text-foreground-status-success' : 'text-foreground-prominent'
        )}
      >
        <p className={clsx('text-body-regular')}>{t('embeddedCustomers.dashboard.queue')}</p>
        <h3 className={clsx('text-h3', type !== 'success' && 'text-foreground-subdued')}>
          {queue} {t('embeddedCustomers.dashboard.customers')}
        </h3>
      </Box>
    </Box>
  )
}
